export const colors = {
  primary: '#5e893c',
  danger: '#bf3139',
  yellow: '#fec14a',
  success: '#43c515',
  blue: '#00559E',
};
